export function ChatLoadError({ error }: { error: Error }) {
  return (
    <div
      className="flex h-full items-center justify-center p-4 text-center text-body text-destructive"
      data-testid="chat-load-error"
    >
      Failed to load conversation: {error.message}
    </div>
  );
}
